import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Paysure = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Public Key</label>
                <TextField
                    error={(error.paysure_public_key) && true}
                    value={account.paysure_public_key || ''}
                    onChange={e => {
                        dispatch(change({paysure_public_key: e.target.value}))
                        if (error.paysure_public_key && delete error.paysure_public_key);
                    }}
                />

                {(error.paysure_public_key) &&
                    <strong className="text-danger">{error.paysure_public_key[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Secret Key</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.paysure_secret_key) && true}
                    value={account.paysure_secret_key || ''}
                    onChange={e => {
                        dispatch(change({paysure_secret_key: e.target.value}))
                        if (error.paysure_secret_key && delete error.paysure_secret_key);
                    }}
                />

                {(error.paysure_secret_key) &&
                    <strong className="text-danger">{error.paysure_secret_key[0]}</strong>
                }
            </div>
        </>
    )
}


export default Paysure